import React from 'react';
import styles from './index.module.scss';
import Loading from '@/components/common/Loading';

export default function WaitLoading() {
  return (
    <div className={styles.WaitClaimLoading}>
      <div className={styles.loadingIcon}>
        <Loading className={styles.loadingImg} />
      </div>
    </div>
  );
}
